import { useEffect, useState } from "react"
import Icon, { type AvailableIcons } from "~/components/ui/Icon"
import type { ImageWidget } from "~/types/widgets"
import ImageComponent from "~/components/ui/Image"

/** @titleBy alt */
interface Image {
    /** @ignore */
    type: "@Image"
    /** @title Imagem */
    image: ImageWidget
    /** @title Largura */
    width: number
    /** @title Altura */
    height: number
    /** @title Texto alternativo */
    alt: string
    url?: string
}

/** @titleBy alt */
interface Svg {
    /** @ignore */
    type: "@Svg"
    /** @title Ícones */
    icon: AvailableIcons
    /** @title Largura */
    width: number
    /** @title Altura */
    height: number
    /** @title Texto alternativo */
    alt: string
    url?: string
}

/** @titleBy alt */
type Item = Image | Svg

/**
 * @title Imagens
 * @description Imagens mostradas no final do footer
 */
export interface Props {
    /** @title Imagens */
    images: Item[]
}

export default function Social({ images }: Props) {
    const [isHome, setIsHome] = useState(false)

    useEffect(() => {
        setIsHome(window.location.pathname === "/")
    }, [])

    return (
        <ul className="flex justify-center gap-4">
            {images.map((item, idx) => (
                <li key={idx}>
                    {"image" in item && (
                        <ImageComponent
                            src={item.image}
                            width={item.width}
                            height={item.height}
                            alt={item.alt}
                            loading="lazy"
                        />
                    )}
                    {"icon" in item && (
                        isHome && item.url ? (
                            <a href={item.url} target="_blank" rel="noopener noreferrer">
                                <Icon
                                    id={item.icon as AvailableIcons}
                                    width={item.width}
                                    height={item.height}
                                />
                            </a>
                        ) : (
                            <Icon
                                id={item.icon as AvailableIcons}
                                width={item.width}
                                height={item.height}
                            />
                        )
                    )}
                </li>
            ))}
        </ul>
    )
}
